import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  shallowEqual,
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';
import { setupListeners } from '@reduxjs/toolkit/query';
import appSlice from './slices/app.slice';
import { workshopsApi } from './apiSlice/workshops.slice';

const appReducer = combineReducers({
  appSlice: appSlice.reducer,
  [workshopsApi.reducerPath]: workshopsApi.reducer,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setupStore = (initialState: Record<string, any> = {}) =>
  configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(workshopsApi.middleware),
    preloadedState: initialState,
  });

export const store = setupStore();

export const clearAllCachedData = () => {
  store.dispatch(workshopsApi.util.resetApiState());
};

export type RootState = ReturnType<typeof rootReducer>;
type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = cb =>
  useSelector(cb, shallowEqual);

setupListeners(store.dispatch);
